// Deterministic avatar helpers for player identity.
// Same name → same initials & accent color, so a player keeps a stable
// in-game face across sessions.

export function getInitials(name = "") {
  const trimmed = String(name).trim();
  if (!trimmed) return "?";
  const parts = trimmed.split(/\s+/).filter(Boolean);
  if (parts.length >= 2) {
    return (parts[0][0] + parts[1][0]).toUpperCase();
  }
  // Single token: take first 2 alphanumerics
  const letters = parts[0].replace(/[^A-Za-z0-9]/g, "");
  return (letters.slice(0, 2) || parts[0].slice(0, 2)).toUpperCase();
}

// FNV-1a 32-bit hash (small + deterministic; JS-safe ints)
function hash(s) {
  let h = 0x811c9dc5;
  for (let i = 0; i < s.length; i++) {
    h ^= s.charCodeAt(i);
    h = (h + ((h << 1) + (h << 4) + (h << 7) + (h << 8) + (h << 24))) >>> 0;
  }
  return h >>> 0;
}

// Pleasant, saturated, dark-bg-friendly accent palette.
const PALETTE = [
  "#FFD700", "#7B61FF", "#00C2FF", "#FF5C8A", "#3DDC97",
  "#FF8A3D", "#A4F03A", "#F5475C", "#56C8FF", "#E94EFF",
  "#FFC857", "#5BD2C2",
];

export function colorFromName(name = "") {
  const idx = hash(String(name).toLowerCase()) % PALETTE.length;
  return PALETTE[idx];
}
